import {find} from 'lodash';
import {useContext, useEffect} from 'react';

import {DynamicComponentNames} from 'constants/client';
import {ClientContext} from 'context';

import {DynamicContent, DynamicContentProps} from '../DynamicContent';

type Props = {
    defaultTemplate: string;
    component: DynamicComponentNames;
} & Omit<DynamicContentProps, 'template'>

export const ClientDynamicContent: React.FC<Props> = ({component, defaultTemplate, ...rest}: Props) => {
    const ctx = useContext(ClientContext);
    const settings = ctx?.settings;
    const componentSettings = find(settings?.whiteLabel?.components, {name: component});
    const template = componentSettings?.template || defaultTemplate;
    const styles = componentSettings?.styles;

    useEffect(() => {
        if (styles) {
            const head = document.head;
            const styleElement = document.createElement('style');
            styleElement.appendChild(document.createTextNode(styles));
            head.appendChild(styleElement);
            return () => {
                head.removeChild(styleElement);
            };
        }
    }, [styles]);

    return (
        <DynamicContent template={template} {...rest} />
    );
};
